import _get from 'lodash/get';
import { premiumService } from '@bedrock/fido-sdk';

export const getPremiumUserContractModel = subscriptions =>
  subscriptions
    ? subscriptions.current.map(contract => ({
        offer: _get(contract, 'offer.title'),
        features: _get(contract, 'offer.features', []).map(feature => feature && feature.code),
        price: _get(contract, 'current_contract.variant.recurring_price') || 0,
        products: _get(contract, 'offer.short_products', []).map(({ code }) => code),
        currency: _get(contract, 'current_contract.variant.currency', ''),
      }))
    : [];

export const getPremiumSubscriptions = userId =>
  premiumService.getUserSubscriptions({ user: { UID: userId } }).then(getPremiumUserContractModel);
